import React from "react";
import SegmentList from './SegmentList';
import Pagination from './Pagination';
import axios from "axios";
import $ from "jquery";

class Totals extends React.Component {
    render(){
        var currentPageCount = this.props.next + this.props.perPage;
        if(currentPageCount > this.props.count) currentPageCount = this.props.count; //account for half full pages
        return (
            <p><strong>Showing {this.props.next + 1} to {currentPageCount} of {this.props.count} segments</strong></p>
        );
    }
}

class SegmentCard extends React.Component{
    render(){
        var edit = "/dashboard/segment/edit/"+this.props.ID;
        var insights = "/dashboard/segment/insights/"+this.props.ID;
        var image = "/dashboard/segment/image/"+this.props.ID;
        var brandpage = "/dashboard/manage/edit/"+this.props.BrandID;
        var insightsLink = (this.props.Name === "Basic Social Listening") ? "" :
            <a href={insights} className="btn btn-primary btn-xs mt-1 waves-effect waves-light float-end">Insights</a>;

        return(
            <div className="col segment-card">
                <div className="card">
                    <div className="card-image">
                        <a href={insights}>
                            <img src={image} className="card-img-top" alt={this.props.Name} />
                        </a>
                    </div>
                    <div className="card-body">
                        <a href={insights}>
                            <h5 className="card-title">{this.props.Name}</h5>
                        </a>    
                        <a href={brandpage}>    
                            <p className="card-text">{this.props.BrandName}</p>
                        </a>    
                        <p className="card-text">{this.props.Blurb}</p>
                    </div>
                    <br />
                    <div className="card-buttons row">
                        {insightsLink}
                        <a href={edit} className="btn btn-outline-primary btn-xs mt-1 waves-effect waves-light float-end mr-10">Manage</a>
                    </div>
                </div>
            </div>
        );
    }
} 

class SegmentsHolderPage extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            "allSegments": null, //contains all segments for the business unit
            "segmentsLoaded": false,
            "matchedSegments": null, //contains segments matched by search criteria
            "segmentsCount": null,
            "matchesCount": null,
            "next" : 0,//contains offset for next 11 items eg. 0, 11, 22, 33
            "pagingRefresh": 0
        };
    }

    componentDidMount() {
        this.getSegments();
    }

    componentDidUpdate(prevProps, prevState, snapshot){
        if(this.state.allSegments && !this.state.segmentsLoaded) {
            this.setState({
                segmentsLoaded: true,
            });            

            var parent = this;
            $("#SegmentSelector").on( "keyup", function(e){
                parent.onKeyPressed(e.target.value);
            }); 
        } 
    }

    getSegments(){
        var url = "react/process?endpoint=segments&orderBy=Created+DESC&excludeBasicSocial=1&turnoffdebug=1&IgnoreSegmentFilters=1";
        var cacheKey = $(".segmentlistcachekey").data("segmentlistcachekey");
        if(cacheKey) url += "&cacheKey="+cacheKey;
        // console.log(url);
        axios.get(url).then(response => this.formatData({"allSegments": response.data}));
    }

    formatData(data){
        if(data.allSegments){
            //ensure Basic Social always appears first
            let basicSocialKey = data.allSegments.findIndex(segment => segment.Name === "Basic Social Listening");
            let basicSocial = data.allSegments.splice(parseInt(basicSocialKey), 1);
            if(basicSocial) data.allSegments = $.merge(basicSocial, data.allSegments);
            data.segmentsCount = Object.keys(data.allSegments).length;
        }
        this.setState(data);
    }

    onKeyPressed = (clue) => { 
        var matches = this.getSegmentsByClue(clue);
        var count = matches ? Object.keys(matches).length : 0;

        this.setState({
            next: 0, //reset totals
            pagingRefresh: Date(),//reset paging
            matchedSegments: matches,
            matchesCount: count,
        });
    }

    getSegmentsByClue = (clue) => {
        var segments = this.state.allSegments;
        var brand_matches = segments.filter(function(segment){
            if(segment.BrandName) return segment.BrandName.toLowerCase().includes(clue.toLowerCase());
        });
        
        var segment_matches = segments.filter(function(segment){
            if(segment.Name) return segment.Name.toLowerCase().includes(clue.toLowerCase());
        });

        var matches = [].concat(brand_matches, segment_matches);       
        return matches.filter(function(val, key, array) {//remove duplicates
            return key === array.indexOf(val);
        });
    }

    clearFilters = (e) => {
        e.preventDefault();
        $('#SegmentSelector').val("");

        this.setState({
            matchedSegments: null,
            matchesCount: null
        });
    }

    paginationHandler(next){
        this.setState({
            next: next,
        });
    }

    render() {
        var segments = {};
        var segmentsCount = 0;
        if(this.state.matchedSegments) {
            segments = this.state.matchedSegments;
            segmentsCount = this.state.matchesCount;
        } else if(this.state.allSegments) {
            segments = this.state.allSegments;
            segmentsCount = this.state.segmentsCount;
        }

        const parent = this;

        //display segments by current page, handles pagination
        if(Object.keys(segments).length > this.props.perPage) {
            segments = segments.slice(this.state.next, (this.state.next + this.props.perPage));
        }

        var filterText = "";
        if(this.state.matchedSegments) filterText += segmentsCount+" matching segments";
        else filterText += segmentsCount+" total segments (by brand)";

        return(
            <div>
                <form>
                    <div className="row mb-3">
                        <label className="col-md-3 col-form-label"> Filter by brand or segment:</label>
                        <div className="col-md-3 form-field-height mb-2 brandlist-holder">
                            <SegmentList type="typeahead" sendToPage={parent.onKeyPressed.bind(this)} />
                        </div>  
                        <div className="col-md-2">
                            <button className="btn btn-danger mb-3 waves-effect waves-light float-end" 
                                    onClick={(e) => this.clearFilters(e)}>Clear</button>
                        </div>               
                    </div>
                </form>

                <div className="row">
                    <div className="col-12">
                        <h5 className="mt-2 mb-3">{filterText}</h5>
                        <div className="row row-cols-2 row-cols-lg-6 row-cols-md-4 row-cols-sm-3 g-2 card-overview">
                            <div className="col">
                                <a href="dashboard/segment/add" className="new-card-link">
                                    <div className="card card-new">
                                        <div className="card-body">
                                            <i className="fas fa-plus-circle"></i>
                                            <br/>Add new segment
                                        </div>
                                    </div>
                                </a>
                            </div>
                            {Object.entries(segments).map(function(obj, key) {
                               return <SegmentCard key={key} ID={obj[1].ID} Name={obj[1].Name} 
                                                 BrandName={obj[1].BrandName} BrandID={obj[1].BrandID} />;
                            })}
                        </div>
                    </div>
                </div>

                <div className="table-controls">
                    <Totals perPage={this.props.perPage} next={this.state.next} count={segmentsCount} />
                    <Pagination perPage={this.props.perPage} sendToPage={parent.paginationHandler.bind(this)} 
                                count={segmentsCount} refreshToken={this.state.pagingRefresh} />
                </div>    

            </div>
        );
    }
}

SegmentsHolderPage.defaultProps = {
    perPage: 11
};

export default SegmentsHolderPage;